export const TOAST_DEFAULT_DURATION = 2600;
export const TOAST_PRIORITY_DEFAULT = 'info';
export const TOAST_PRIORITY_LEVELS = ['info', 'warn', 'error'];

// Suppress global toasts while onboarding is active on phone-class viewports.
export const TOAST_SUPPRESS_DURING_ONBOARDING_ON_PHONE = true;
export const TOAST_PHONE_SHORT_EDGE_MAX_PX = 520;

// Behavior for critical (error) toasts while suppressed:
// - 'inline': render inside onboarding coachmark
// - 'bypass': allow global toast render
export const TOAST_SUPPRESSED_ERROR_MODE = 'inline';
export const TOAST_SUPPRESSION_BYPASS_PRIORITIES = ['error'];
export const TOAST_INLINE_STATUS_DURATION_MS = 5200;
export const TOAST_INLINE_STATUS_MAX_CHARS = 96;

export const TOASTS = {
    libraryNameRequired: {
        title: 'Library name required',
        message: 'Give it a short name (you can rename later).',
        duration: TOAST_DEFAULT_DURATION
    },
    uploadFailed: (reason) => ({
        title: 'Upload Failed',
        message: reason || '',
        duration: 0
    }),
    noLibrarySelected: {
        title: 'No Library Selected',
        message: 'Please select a library first.',
        duration: 0
    },
    uploadComplete: (message) => ({
        title: 'Upload Complete',
        message,
        duration: 20000
    }),
    buildStarted: (message) => ({
        title: 'Creating a masterpiece...',
        message,
        duration: 20000
    }),
    jobCancelled: (message) => ({
        title: 'Cancelled',
        message,
        duration: 0
    }),
    libraryProcessing: {
        title: 'Processing',
        message: 'Optimizing library in background...',
        duration: 0
    },
    libraryOptimized: {
        message: 'Library optimized.<br><b>Done!</b>'
    }
};
